module.exports = __webpack_public_path__ + "img/amToEn.dcff6a8a.png";